import { useContext } from "react";
import type { VerifyAccountStep } from "./verifyAccountSteps";
import { VerifyAccountStepContext } from "./VerifyAccountStepContext";

export function useVerifyAccountStep(): {
	step: VerifyAccountStep;
	setStep: (step: VerifyAccountStep) => void;
} {
	const ctx = useContext(VerifyAccountStepContext);
	if (!ctx) {
		throw new Error(
			"useVerifyAccountStep must be used within VerifyAccountStepProvider",
		);
	}
	return ctx;
}
